/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable array-callback-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unescaped-entities */
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import ReactSelect from 'react-select';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import Modal from '../Modal';
import ModalText from './Modal';
import Loader from '../../Loader';
import Button from '../../Button';
import Card from '../Card';
import AddPaymentCard from '../AddPaymentCard';
import { formatPrice } from '../../../utils/currencyFormatter';

import {
  Container,
  Content,
  CardSection,
  Circle,
  ModalContentBanner,
  CartaoDados,
  PagamentoDados,
  DivGeralCartao,
} from './styles';
import { Row, Column } from '../../../styles/components';

import { useToast } from '../../../hooks/toast';
import { useLoader } from '../../../hooks/loader';

import TicketingService, {
  Card as CardInterface,
  Payment as Pay,
} from '../../../services/ticketing';
import InputOutlined from '../../InputOutlined';
import ModalPix from './ModalPix';
import AccountsService from '../../../services/accounts';
import { useAuth } from '../../../hooks/auth';
import { PaymentMethod } from './PaymentMethod';
import { InformValue } from './InformValue';
import { Restrictions } from './Restrictions';
import SuccessInfo from './SuccessInfo';

interface RechargerCard {
  cards: CardInterface[];
}

interface RechargeLimit {
  minimum: number;
  maximum: number;
  rate: number;
}

const RechargerCard: React.FC<RechargerCard> = ({ cards, ...rest }) => {
  const { push } = useHistory();
  const { addToast } = useToast();
  const { signOut } = useAuth();
  const { changeLoader } = useLoader();
  const [loading, setLoading] = useState(true);
  const services = { ticketingService: new TicketingService() };
  const inputRef = useRef<any>(null);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [hasCreditCard, setHasCreditCard] = useState<boolean>(false);
  const [showAddPayment, setShowAddPayment] = useState<boolean>(false);
  const [modalPhone, setModalPhone] = useState<boolean>(false);
  const [modalCpf, setModalCpf] = useState<boolean>(false);
  const [successType, setSuccessType] = useState<string>();
  const [boletoLink, setBoletoLink] = useState<string>();
  const [payments, setPayments] = useState<Pay[]>([]);
  const [paymentSelected, setPaymentSelected] = useState<number>();
  const [cardSelected, setCardSelected] = useState<number>();
  const [cashSelected, setCashSelected] = useState<number>();
  const [payType, setPayType] = useState<string>('');
  const [pixCode, setPixCode] = useState<any>();
  const [pixImage, setPixImage] = useState<any>();
  const [pixExpiration, setPixExpiration] = useState<any>();
  const formRef = useRef<FormHandles>(null);
  const [rechargeLimits, setRechargeLimits] = useState<
    Record<string, RechargeLimit>
  >({});
  const [isApplePayAvailable, setIsApplePayAvailable] = useState(false);
  const [isGooglePayAvailable, setIsGooglePayAvailable] = useState(false);
  const servicesProfile = { AccountsService: new AccountsService() };
  const [phones, setPhones] = React.useState([]);
  const [cpfs, setCpfs] = React.useState([]);
  const [disable, setDisable] = useState(false);
  const currentLimit = rechargeLimits[payType];

  const [tamanhotela, setTamanhotela] = useState(window.innerWidth);
  const [saldocartao, setSaldoCartao] = React.useState();
  const [eyechange, setEyechange] = React.useState<boolean>(false);

  const [collapsed, setCollapsed] = useState(false);

  const applePayRef = useRef<HTMLElement>(null);

  const getCardsAsync = async () => {
    setLoading(true);
    const idCard = window.location.pathname.split('/');
    const response = await services.ticketingService.getCard(
      idCard[idCard.length - 1],
    );
    setCardSelected(response?.data?.id);
    setSaldoCartao(response.data?.balance);
    // changeLoader(false);
    setLoading(false);
  };

  useEffect(() => {
    getCardsAsync();
  }, [window.location.pathname]);

  useEffect(() => {
    function handleResize() {
      setTamanhotela(window.innerWidth); // Atualiza a página quando o tamanho da tela muda
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  async function asyncGetBoletoLimit() {
    try {
      setLoading(true);
      const response = await services.ticketingService.getBoletoLimit();
      const limits = response.data.results.reduce((acc: any, item: any) => {
        acc[item.payment_type] = {
          minimum: item.minimum,
          maximum: item.maximum,
          rate: item.rate,
        };

        return acc;
      }, {});

      setRechargeLimits(limits);

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  useEffect(() => {
    async function getProfile() {
      try {
        const response = await servicesProfile.AccountsService.getProfile();
        setPhones(response?.data?.phone);
        setCpfs(response?.data?.cpf);
      } catch (err) {
        const { ...error }: any = err;

        addToast({
          type: 'error',
          title: `${
            error?.response?.data?.message
              ? error?.response?.data?.message
              : 'Erro no Servidor'
          }`,
          description: `${
            error?.response?.data?.sub_message
              ? error?.response?.data?.sub_message
              : 'Tente deslogar e logar novamente, caso o erro persista entre em contato com o Administrador'
          }`,
        });
        if (err) {
          signOut();
        }
        console.error(err);
      }
    }
    getProfile();
  }, []);

  useEffect(() => {
    async function getFaqs() {
      try {
        const response = await services.ticketingService.getPaymentForm();
        setPayments(response.data.results);
        const filteredPayments = response.data.results.filter(
          (type: any) => type.payment_type === 'credit_card',
        );

        setHasCreditCard(!!filteredPayments.length);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    }

    getFaqs();
    asyncGetBoletoLimit();
  }, []);

  const handleRedirect = useCallback(
    pathLink => {
      push(pathLink);
    },
    [push],
  );

  const handleCard = useCallback(
    idCard => {
      setCardSelected(idCard);
    },
    [setCardSelected],
  );

  const handlePayment = useCallback(
    paymentId => {
      setPaymentSelected(paymentId);
    },
    [setPaymentSelected],
  );

  const success = useCallback((type, link, pixImg, pixCod, pixExp) => {
    setSuccessType(type);
    setBoletoLink(link);
    setShowSuccess(true);
    setPixImage(pixImg);
    setPixCode(pixCod);
    setPixExpiration(pixExp);
  }, []);

  const closeModal = useCallback(() => {
    setShowSuccess(false);
    push('/meus-cartoes');
  }, [push]);

  const handleAddCreditCard = useCallback(async () => {
    try {
      const response = await services.ticketingService.getPaymentForm();
      setPayments(response.data.results);
      const filteredPayments = response.data.results.filter(
        (type: any) => type.payment_type === 'credit_card',
      );
      setHasCreditCard(!!setHasCreditCard.length);
    } catch (err: any) {
      const { ...error } = err;
      console.error(error);
    }
  }, []);

  const currentRate = rechargeLimits[payType]?.rate || 0;

  const handleCash = useCallback(
    async cashValue => {
      const paymentType: Pay = payments.filter(
        pay => pay.id === paymentSelected,
      )[0];

      if (
        paymentType.payment_type === 'boleto' &&
        Number(inputRef.current.state.numAsString) <
          Number(rechargeLimits.boleto.maximum)
      ) {
        const addedValue =
          Number(inputRef.current.state.numAsString) + cashValue;

        const setValue =
          addedValue > rechargeLimits.boleto.maximum
            ? rechargeLimits.boleto.maximum
            : addedValue;

        setCashSelected(setValue);
      }
      if (
        paymentType.payment_type === 'credit_card' &&
        Number(inputRef.current.state.numAsString) <
          Number(rechargeLimits.credit_card.maximum)
      ) {
        const addedValue =
          Number(inputRef.current.state.numAsString) + cashValue;

        const setValue =
          addedValue > rechargeLimits.credit_card.maximum
            ? rechargeLimits.credit_card.maximum
            : addedValue;

        setCashSelected(setValue);
      }
      if (
        paymentType.payment_type === 'pix' &&
        Number(inputRef.current.state.numAsString) <
          Number(rechargeLimits.pix.maximum)
      ) {
        const addedValue =
          Number(inputRef.current.state.numAsString) + cashValue;

        const setValue =
          addedValue > rechargeLimits.pix.maximum
            ? rechargeLimits.pix.maximum
            : addedValue;

        setCashSelected(setValue);
      }
    },
    [rechargeLimits, payments, paymentSelected, cashSelected],
  );

  const handleSubmit = useCallback(async () => {
    try {
      const data = formRef.current?.getData();

      const paymentType: Pay = payments.filter(
        pay => pay.id === paymentSelected,
      )[0];

      const idCard = window.location.pathname.split('/');

      if (!phones || !cpfs) {
        if (!phones) {
          setModalPhone(true);
        } else {
          setModalCpf(true);
        }
      } else {
        if (
          paymentType?.payment_type === 'credit_card' &&
          Number(inputRef?.current?.state?.numAsString) >
            Number(rechargeLimits.credit_card.maximum)
        ) {
          addToast({
            type: 'info',
            title: `Limite Máximo de Recarga Por Cartão de crédito é de ${rechargeLimits.credit_card.maximum}`,
          });
          return;
        }
        if (data) {
          if (
            Object.values(data.cvv).length < 3 &&
            paymentType?.payment_type === 'credit_card'
          ) {
            addToast({
              type: 'error',
              title: 'CVV não informado',
            });
            return;
          }
        }

        if (
          paymentType?.payment_type === 'boleto' &&
          Number(inputRef?.current?.state?.numAsString) >
            Number(rechargeLimits.boleto.maximum)
        ) {
          addToast({
            type: 'info',
            title: `Limite Máximo de Recarga Pelo Meio de Pagamento Boleto é de R$${rechargeLimits.boleto.maximum}`,
          });
          return;
        }

        if (
          paymentType?.payment_type === 'pix' &&
          Number(inputRef?.current?.state?.numAsString) >
            Number(rechargeLimits.pix.maximum)
        ) {
          addToast({
            type: 'info',
            title: `Limite Máximo de Recarga Pelo Meio de Pagamento PIX é de R$${rechargeLimits.pix.maximum}`,
          });
          return;
        }
        changeLoader(true);
        const response = await services.ticketingService.rechargeCard(
          cardSelected,
          paymentSelected,
          cashSelected,
          data ? data.cvv : null,
        );
        setDisable(true);

        setCardSelected(null);

        setCashSelected(null);

        setPaymentSelected(null);

        changeLoader(false);

        success(
          paymentType.payment_type,
          response.data.tacom_boleto,
          response.data.pix_image_link,
          response.data.pix_copy_paste,
          response.data.pix_expiration,
        );
        setDisable(false);
      }
    } catch (err: any) {
      console.log(err);
      changeLoader(false);
      const { ...error } = err;
      if (error?.response?.data?.message) {
        addToast({
          type: 'error',
          title: `${error?.response?.data?.message}`,
          description:
            error?.response?.data?.sub_message &&
            `${error?.response?.data?.sub_message}`,
        });
      } else {
        addToast({
          type: 'error',
          title: 'Error',
          description:
            'Estamos com instabilidades no sistema, por favor tente novamente mais tarde.',
        });
      }
    }
  }, [payments, paymentSelected, cardSelected, cashSelected, phones]);

  const handleSubmitCVV = useCallback(() => {
    console.log('submit');
  }, []);

  const handleSelectBlur = useCallback(
    payment => {
      if (payment.payment_type === 'boleto') {
        const paymentType: Pay = payments.filter(
          pay => pay.payment_type === payment.payment_type,
        )[0];

        setPayType('boleto');

        setPaymentSelected(paymentType.id);
      }

      if (payment.payment_type === 'credit_card') {
        setPayType('credit_card');
      }

      if (payment.payment_type === 'pix') {
        const paymentType: Pay = payments.filter(
          pay => pay.payment_type === payment.payment_type,
        )[0];

        setPayType('pix');

        setPaymentSelected(paymentType.id);
      }

      if (payment.payment_type === 'googlepay') {
        const paymentType: Pay = payments.filter(
          pay => pay.payment_type === payment.payment_type,
        )[0];

        setPayType('googlepay');

        setPaymentSelected(paymentType.id);
      }

      if (payment.payment_type === 'applepay') {
        const paymentType: Pay = payments.filter(
          pay => pay.payment_type === payment.payment_type,
        )[0];

        setPayType('applepay');

        setPaymentSelected(paymentType.id);
      }
    },
    [payments, collapsed],
  );

  const handleGooglePay = async (client: any) => {
    if (!client) {
      console.error('Google Pay client não encontrado');
      return;
    }
    const paymentType: Pay = payments.filter(
      pay => pay.id === paymentSelected,
    )[0];

    const paymentDataRequest = {
      apiVersion: 2,
      apiVersionMinor: 0,
      allowedPaymentMethods: [
        {
          type: 'CARD',
          parameters: {
            allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
            allowedCardNetworks: [
              'AMEX',
              'DISCOVER',
              'INTERAC',
              'JCB',
              'MASTERCARD',
              'VISA',
            ],
          },
          tokenizationSpecification: {
            type: 'PAYMENT_GATEWAY',
            parameters: {
              gateway: 'cielo',
              gatewayMerchantId: process.env.REACT_APP_GOOGLE_PAY_MERCHANT_ID,
            },
          },
        },
      ],
      merchantInfo: {
        merchantName: 'Transfacil',
        merchantId: process.env.REACT_APP_GOOGLE_MERCHANT_ID,
      },
      transactionInfo: {
        totalPriceStatus: 'FINAL',
        totalPrice: String(cashSelected),
        currencyCode: 'BRL',
      },
    };

    try {
      const paymentData = await client.loadPaymentData(paymentDataRequest);
      const rawToken = paymentData.paymentMethodData.tokenizationData.token;

      const parsedToken = JSON.parse(rawToken);

      const tokentoSend = parsedToken.signedMessage;
      const tokentoSendParsed = JSON.parse(tokentoSend);

      const wallet = {
        Type: 'AndroidPay',
        WalletKey: parsedToken.signedMessage,
        AdditionalData: {
          Signature: parsedToken.signature,
        },
      };

      changeLoader(true);
      const response = await services.ticketingService.rechargeCard(
        cardSelected,
        paymentSelected,
        cashSelected,
        null,
        wallet,
      );

      changeLoader(false);
      success(
        paymentType.payment_type,
        response.data.tacom_boleto,
        response.data.pix_image_link,
        response.data.pix_copy_paste,
        response.data.pix_expiration,
      );
    } catch (error: any) {
      if (error?.response?.data?.message) {
        addToast({
          type: 'error',
          title: `${error?.response?.data?.message}`,
          description:
            error?.response?.data?.sub_message &&
            `${error?.response?.data?.sub_message}`,
        });
      } else if (error.statusCode === 'CANCELED') {
        addToast({
          type: 'error',
          title: 'Error',
          description: 'Operação cancelada pelo usuário',
        });
        changeLoader(false);
      } else {
        addToast({
          type: 'error',
          title: 'Error',
          description: 'Erro ao processar pagamento',
        });
      }
      changeLoader(false);
    }
  };

  const handleApplePay = () => {
    if (!window.ApplePaySession) {
      console.error('Apple Pay não disponível');
      return;
    }

    const paymentType: Pay = payments.filter(
      pay => pay.id === paymentSelected,
    )[0];

    const session = new window.ApplePaySession(3, {
      countryCode: 'BR',
      currencyCode: 'BRL',
      supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
      merchantCapabilities: ['supports3DS'],
      total: {
        label: 'Transfacil',
        amount: String(cashSelected),
      },
    });

    session.onvalidatemerchant = async (event: any) => {
      try {
        const inicio = Date.now();

        const response = await services.ticketingService.validateRecharge(
          event.validationURL,
        );

        const tempo = Date.now() - inicio;

        const merchantSession = response.data;
        session.completeMerchantValidation(
          typeof merchantSession === 'string'
            ? JSON.parse(merchantSession)
            : merchantSession,
        );
      } catch (error: any) {
        if (error?.response?.data?.message) {
          addToast({
            type: 'error',
            title: `${error?.response?.data?.message}`,
            description:
              error?.response?.data?.sub_message &&
              `${error?.response?.data?.sub_message}`,
          });
        } else {
          addToast({
            type: 'error',
            title: 'Error',
            description: 'Erro ao processar pagamento',
          });
        }
        session.abort();
      }
    };

    session.onpaymentauthorized = async (event: any) => {
      try {
        const token = event.payment.token.paymentData;

        const wallet = {
          Type: 'ApplePay',
          WalletKey: token.data,
          AdditionalData: {
            EphemeralPublicKey: token.header.ephemeralPublicKey,
          },
        };

        const response = await services.ticketingService.rechargeCard(
          cardSelected,
          paymentSelected,
          cashSelected,
          null,
          wallet,
        );

        if (response) {
          session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
        } else {
          session.completePayment(window.ApplePaySession.STATUS_FAILURE);
        }
        success(
          paymentType.payment_type,
          response.data.tacom_boleto,
          response.data.pix_image_link,
          response.data.pix_copy_paste,
          response.data.pix_expiration,
        );
      } catch (error: any) {
        if (error?.response?.data?.message) {
          addToast({
            type: 'error',
            title: `${error?.response?.data?.message}`,
            description:
              error?.response?.data?.sub_message &&
              `${error?.response?.data?.sub_message}`,
          });
        } else {
          addToast({
            type: 'error',
            title: 'Error',
            description: 'Erro ao processar pagamento',
          });
        }
        session.completePayment(window.ApplePaySession.STATUS_FAILURE);
      }
    };

    session.oncancel = (event: any) => {
      console.log('Sessão cancelada:', JSON.stringify(event, null, 2));
    };
    session.begin();
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const eyechangeParam = params.get('eyechange');

    if (eyechangeParam === 'true') {
      setEyechange(true);
    } else {
      setEyechange(false);
    }
  }, [location.search]);

  useEffect(() => {
    if (payType !== 'googlepay') return;

    if (!window.google?.payments?.api) {
      return;
    }

    const paymentsClient = new (window as any).google.payments.api.PaymentsClient(
      {
        environment: process.env.REACT_APP_GOOGLE_PAY_ENV,
      },
    );

    const checkReady = async () => {
      const isReady = await paymentsClient.isReadyToPay({
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [
          {
            type: 'CARD',
            parameters: {
              allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
              allowedCardNetworks: [
                'AMEX',
                'DISCOVER',
                'INTERAC',
                'JCB',
                'MASTERCARD',
                'VISA',
              ],
            },
          },
        ],
      });

      if (!isReady.result) {
        console.log('Google Pay não disponível');
        return;
      }

      const button = paymentsClient.createButton({
        onClick: () => handleGooglePay(paymentsClient),
        buttonType: 'checkout',
        buttonColor: 'black',
        buttonLocale: 'pt',
        buttonSizeMode: 'static',
      });

      const container = document.getElementById('google-pay-button');

      if (!container) {
        return;
      }

      container.innerHTML = '';
      container.appendChild(button);
    };

    checkReady();
  }, [payType, cashSelected, collapsed]);

  useEffect(() => {
    if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
      setIsApplePayAvailable(true);
    }
  }, []);

  useEffect(() => {
    const button = applePayRef.current;
    if (!button) return;

    button.addEventListener('click', handleApplePay);
    return () => button.removeEventListener('click', handleApplePay);
  }, [handleApplePay]);

  useEffect(() => {
    if (!window.google?.payments?.api) {
      setIsGooglePayAvailable(false);
      return;
    }

    const paymentsClient = new (window as any).google.payments.api.PaymentsClient(
      {
        environment: process.env.REACT_APP_GOOGLE_PAY_ENV,
      },
    );

    const checkReady = async () => {
      try {
        const response = await paymentsClient.isReadyToPay({
          apiVersion: 2,
          apiVersionMinor: 0,
          allowedPaymentMethods: [
            {
              type: 'CARD',
              parameters: {
                allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                allowedCardNetworks: ['VISA', 'MASTERCARD'],
              },
            },
          ],
        });

        setIsGooglePayAvailable(response.result);
      } catch (error) {
        console.error('Erro ao verificar Google Pay', error);
        setIsGooglePayAvailable(false);
      }
    };

    checkReady();
  }, []);

  useEffect(() => {
    if (!collapsed) {
      setPayType('');

      setPaymentSelected(undefined);
    }
  }, [collapsed]);

  return (
    <Container {...rest}>
      {loading ? (
        <Loader />
      ) : (
        <>
          <DivGeralCartao>
            <CartaoDados>
              {cards &&
                cards
                  .filter(card => card.id === cardSelected)

                  .map((card: CardInterface) => (
                    <Column key={card.id} small="12" medium="8" large="6">
                      <Card
                        nickname={card.nickname}
                        cardNumber={card.card_number}
                        selected={cardSelected === card.id}
                        saldo={saldocartao}
                        recharge={true}
                        id={card.id}
                        eye={eyechange}
                      />
                    </Column>
                  ))}
              <p className="textotcard">
                Deseja &nbsp;
                <a className="textlink" href="/meus-cartoes">
                  carregar outro Cartão?
                </a>
              </p>
              {/* {tamanhotela > 700 && (
                <>
                  <p className="text">Resumo da compra</p>
                  <div className="resume">
                    <div className="value">
                      <span>Recarga</span>
                      {!!cashSelected && (
                        <span>{formatPrice(cashSelected)}</span>
                      )}
                    </div>
                    <div className="tax">
                      <span>Taxa de serviço</span>
                      {!!cashSelected &&
                        (payType === 'credit_card'
                          ? `${formatPrice(currentRate * cashSelected)}`
                          : payType === 'boleto'
                          ? `${formatPrice(currentRate * cashSelected)}`
                          : payType === 'pix'
                          ? `${formatPrice(currentRate * cashSelected)}`
                          : payType === 'googlepay'
                          ? `${formatPrice(currentRate * cashSelected)}`
                          : payType === 'applepay'
                          ? `${formatPrice(currentRate * cashSelected)}`
                          : '')}
                    </div>
                    <div className="tax">
                      <span>Total</span>
                      {!!cashSelected &&
                        (payType === 'credit_card'
                          ? `${formatPrice(
                              currentRate * cashSelected + cashSelected,
                            )}`
                          : payType === 'boleto'
                          ? `${formatPrice(
                              currentRate * cashSelected + cashSelected,
                            )}`
                          : payType === 'pix'
                          ? `${formatPrice(
                              currentRate * cashSelected + cashSelected,
                            )}`
                          : payType === 'googlepay'
                          ? `${formatPrice(
                              currentRate * cashSelected + cashSelected,
                            )}`
                          : payType === 'applepay'
                          ? `${formatPrice(
                              currentRate * cashSelected + cashSelected,
                            )}`
                          : '')}
                    </div>
                  </div>
                </>
              )} */}
            </CartaoDados>
            <PagamentoDados>
              {cardSelected && (
                <>
                  <PaymentMethod
                    selectedPayment={
                      payments.find(pay => pay.payment_type === payType) || null
                    }
                    onSelectPayment={handleSelectBlur}
                    onCollapsedChange={setCollapsed}
                  />

                  {payType === 'boleto' && (
                    <small className="text" style={{ marginBottom: '15px' }}>
                      <div className="limit-header">
                        * Atenção! Pagamentos realizados via boleto podem ser
                        compensados pelo banco em até 72 horas.
                      </div>
                    </small>
                  )}

                  {payType === 'credit_card' && (
                    <small className="text" style={{ marginBottom: '15px' }}>
                      <div
                        className="limit-header"
                        style={{ color: 'var(--orange)' }}
                      >
                        * Atenção! As compras na modalidade cartão de crédito
                        estão limitados a 1 compra diária por usuário.
                      </div>
                    </small>
                  )}

                  {payType === 'credit_card' && (
                    <div className="content-payment-form">
                      {payments.map(pay =>
                        pay.is_active && pay.payment_type === 'credit_card' ? (
                          <>
                            <>
                              <Content
                                key={pay.id}
                                onClick={() => handlePayment(pay.id)}
                              >
                                <Circle selected={paymentSelected === pay.id}>
                                  <div className="circle1">
                                    <div className="circle2" />
                                  </div>
                                </Circle>
                                <CardSection>
                                  <span className="cartao">
                                    {pay.verbose_name}
                                  </span>
                                </CardSection>
                              </Content>
                            </>
                          </>
                        ) : (
                          <></>
                        ),
                      )}
                      <div className="cvv-wrapper">
                        <Form ref={formRef} onSubmit={handleSubmitCVV}>
                          <InputOutlined
                            cvv
                            name="cvv"
                            id="cvv"
                            placeholder="CVV"
                          />
                        </Form>
                        <Button
                          color="orange"
                          padding="1.0"
                          type="button"
                          onClick={() => setShowAddPayment(true)}
                        >
                          + Adicionar Cartão de crédito
                        </Button>
                      </div>

                      {!hasCreditCard && (
                        <div className="emptyCreditCard">
                          <small>
                            Você não tem Cartão de crédito cadastrado
                          </small>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}

              {payType.length > 0 && collapsed === true && (
                <>
                  <p className="text" style={{ marginTop: '50px' }}>
                    Digite o valor da recarga:
                  </p>

                  <div className="recharge">
                    <div>
                      <InformValue
                        qtyInput={cashSelected}
                        onClick={(values: any) =>
                          setCashSelected(values.floatValue)
                        }
                      />
                      <br />
                      {/* <Restrictions selectedPayment={payType} /> */}
                    </div>
                    <div>
                      <Button
                        color="orange"
                        padding="1.3"
                        rounded
                        className="button"
                        name="recarregar"
                        type="button"
                        onClick={() => handleCash(10)}
                      >
                        + R$ 10
                      </Button>
                      <Button
                        color="orange"
                        padding="1.3"
                        rounded
                        className="button"
                        name="recarregar"
                        type="button"
                        onClick={() => handleCash(20)}
                      >
                        + R$ 20
                      </Button>
                      <Button
                        color="orange"
                        padding="1.3"
                        rounded
                        className="button"
                        name="recarregar"
                        type="button"
                        onClick={() => handleCash(50)}
                      >
                        + R$ 50
                      </Button>
                    </div>
                  </div>
                </>
              )}
              {/* {tamanhotela < 700 && (
                <>
                  <p className="text">Resumo da compra</p>
                  <div className="resume">
                    <div className="value">
                      <span>Recarga</span>
                      {!!cashSelected && (
                        <span>{formatPrice(cashSelected)}</span>
                      )}
                    </div>
                    <div className="tax">
                      <span>Taxa de serviço</span>
                      {!!cashSelected &&
                        (payType === 'credit_card'
                          ? `${formatPrice(currentRate * cashSelected)}`
                          : payType === 'boleto'
                          ? `${formatPrice(currentRate * cashSelected)}`
                          : payType === 'pix'
                          ? `${formatPrice(currentRate * cashSelected)}`
                          : payType === 'googlepay'
                          ? `${formatPrice(currentRate * cashSelected)}`
                          : payType === 'applepay'
                          ? `${formatPrice(currentRate * cashSelected)}`
                          : '')}
                    </div>
                    <div className="tax">
                      <span>Total</span>
                      {!!cashSelected &&
                        (payType === 'credit_card'
                          ? `${formatPrice(
                              currentRate * cashSelected + cashSelected,
                            )}`
                          : payType === 'boleto'
                          ? `${formatPrice(
                              currentRate * cashSelected + cashSelected,
                            )}`
                          : payType === 'pix'
                          ? `${formatPrice(
                              currentRate * cashSelected + cashSelected,
                            )}`
                          : payType === 'googlepay'
                          ? `${formatPrice(
                              currentRate * cashSelected + cashSelected,
                            )}`
                          : payType === 'applepay'
                          ? `${formatPrice(
                              currentRate * cashSelected + cashSelected,
                            )}`
                          : '')}
                    </div>
                  </div>
                </>
              )} */}
              {!!cashSelected &&
                payType !== 'googlepay' &&
                payType !== 'applepay' && (
                  <div className="buttonss">
                    <Button
                      color="orange"
                      padding="3"
                      rounded
                      className="button-confirmar"
                      type="button"
                      onClick={() => handleSubmit()}
                      disabled={disable}
                    >
                      CONFIRMAR
                    </Button>
                    <Button
                      color="white"
                      padding="3.1"
                      rounded
                      className="button-cancelar"
                      type="button"
                      onClick={() => handleRedirect('/meus-cartoes')}
                    >
                      CANCELAR
                    </Button>
                  </div>
                )}
              {!!cashSelected && payType === 'googlepay' && (
                <div className="buttonss">
                  <div id="google-pay-button" style={{ marginTop: '10%' }} />
                </div>
              )}
              {!!cashSelected && payType === 'applepay' && isApplePayAvailable && (
                <div className="buttonss">
                  <apple-pay-button
                    ref={applePayRef}
                    buttonstyle="black"
                    type="buy"
                    locale="pt"
                    style={{
                      minWidth: '271px',
                      height: '48px',
                      marginTop: '10%',
                    }}
                  />
                </div>
              )}
            </PagamentoDados>
          </DivGeralCartao>
        </>
      )}
      {showSuccess && successType !== 'pix' && (
        <Modal
          handleClose={() => closeModal()}
          success
          show={showSuccess}
          successText=""
          typeModal="success"
        >
          <h1>Pedido de recarga recebido com sucesso.</h1>
          {successType === 'credit_card' && (
            <>
              <br />
              <p>
                * Atenção! As compras na modalidade cartão de crédito estão
                limitados a 1 compra diária por usuário.
              </p>
              <SuccessInfo />
            </>
          )}
          {successType === 'boleto' && (
            <>
              <p>
                <a href={boletoLink} target="_blank" rel="noreferrer">
                  Clique aqui &nbsp;
                </a>
                e baixe o boleto. Em até 72 horas após o pagamento do boleto os
                créditos estarão disponíveis.
              </p>
              <SuccessInfo />
            </>
          )}
          {(successType === 'googlepay' || successType === 'applepay') && (
            <SuccessInfo />
          )}
        </Modal>
      )}
      {modalPhone && (
        <ModalText
          handleClose={() => setModalPhone(false)}
          show={modalPhone}
          title="Dados Incompletos"
        >
          <ModalContentBanner>
            <div className="text">
              <p>
                Verificamos que existem dados obrigatórios não preenchidos no
                seu cadastro.
              </p>
              <p>Complete seu cadastro antes de prosseguir.</p>
            </div>
            <Button
              color="orange"
              padding="3.1"
              rounded
              className="button-confirmar"
              type="button"
              onClick={() => handleRedirect('/meu-perfil')}
            >
              CADASTRAR
            </Button>
          </ModalContentBanner>
        </ModalText>
      )}
      {modalCpf && (
        <ModalText
          handleClose={() => setModalCpf(false)}
          show={modalCpf}
          title="Dados Incompletos"
        >
          <ModalContentBanner>
            <div className="text">
              <p>
                Verificamos que existem dados obrigatórios não preenchidos no
                seu cadastro.
              </p>
              <p>Complete seu cadastro antes de prosseguir.</p>
            </div>
            <Button
              color="orange"
              padding="3.1"
              rounded
              className="button-confirmar"
              type="button"
              onClick={() => handleRedirect('/meu-perfil')}
              style={{
                marginTop: '50px',
                minHeight: '20px',
              }}
            >
              CADASTRAR
            </Button>
          </ModalContentBanner>
        </ModalText>
      )}

      {showSuccess && successType === 'pix' && (
        <>
          <ModalPix
            closeModal={() => closeModal()}
            codeExpiration={pixExpiration}
            codePix={pixCode}
            codeImage={pixImage}
          />
        </>
      )}
      {showAddPayment && (
        <AddPaymentCard
          show={showAddPayment}
          title="Adicionar Cartão"
          handleClose={() => setShowAddPayment(false)}
          handleAdd={handleAddCreditCard}
        />
      )}
    </Container>
  );
};

export default RechargerCard;
